import React from 'react';
import { PropTypes as PT } from 'prop-types';
import DropdownComp from 'components/Dropdown/Dropdown';
import _compact from 'lodash/compact';
import _find from 'lodash/find';
import classes from './SelectLocale.module.scss';

class SelectLocale extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      optimisticLocale: null
    };
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (nextProps.languageId !== this.props.languageId) {
      this.setState({ optimisticLocale: null });
    }
  }

  languageOptionsGenerator = () => {
    return (
      <ul className={classes.languageMenu}>
        {this.props.languageOptions.map((option) => {
          const buttonClass = (option.id === this.props.languageId) ? classes.selected : '';
          return (
            <span key={option.id} id={option.id} >
              <button
                className={buttonClass}
                onClick={() => {
                  this.setState({ optimisticLocale: option.id });
                  if (option.id !== this.props.languageId) {
                    this.props.changeLocale(option.id);
                  }
                }}
              >
                {option.displayName}
              </button>
            </span>
          );
        })}
      </ul>
    );
  };

  languageDropdownButton = (open) => {
    const buttonClasses = _compact([
      classes.languageSelect,
      open ? classes.openSelect : '',
      this.props.buttonClass
    ]).join(' ');

    const selectedLocale = this.state.optimisticLocale || this.props.languageId;

    const foundLocale = _find(this.props.languageOptions, { id: selectedLocale });
    return (
      <div className={buttonClasses}>
        {foundLocale ?
          foundLocale.displayName
          : null
        }
      </div>
    );
  };


  render() {
    const dropdownClasses = _compact([
      classes.languageDropdown,
      this.props.dropdownClass
    ]).join(' ');

    return (
      <DropdownComp
        buttonComponent={this.languageDropdownButton()}
        openButtonComponent={this.languageDropdownButton(true)}
        menuComponent={this.languageOptionsGenerator()}
        dropdownClassName={dropdownClasses}
        onOpen={this.props.onOpen}
      />
    );
  }
}

SelectLocale.propTypes = {
  buttonClass: PT.string,
  changeLocale: PT.func,
  dropdownClass: PT.string,
  languageId: PT.string.isRequired,
  languageOptions: PT.array.isRequired,
  onOpen: PT.func
};

SelectLocale.defaultProps = {
  languageOptions: []
};

export default SelectLocale;
